import React from "react";
import { FormattedMessage } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";

import { Switch } from "@material-ui/core";

export function DarkLightMode({ handleToggle }) {
  const currentState = useSelector(state => state.auth, shallowEqual);

  return (
    <div className="swich-wrap">
      <p>
        <FormattedMessage id="GLOBAL.THEME_TEXT" />
      </p>
      <div
        className={`${
          !currentState.darkLightMode ? "darkActive" : ""
        } swich-label`}
      >
        <label className="lightLabel">
          <FormattedMessage id="GLOBAL.LIGHT_TEXT" />
        </label>
        <Switch
          checked={!currentState.darkLightMode}
          onChange={handleToggle}
          color="primary"
          name="checkedB"
          inputProps={{ "aria-label": "primary" }}
        />
        <label className="darkLabel">
          <FormattedMessage id="GLOBAL.DARK_TEXT" />
        </label>
      </div>
    </div>
  );
}
